var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search" },
        [
          _c(
            "el-drawer",
            {
              attrs: {
                title: "我是标题",
                visible: _vm.showDrawer,
                size: "300px",
                "modal-append-to-body": false,
                wrapperClosable: true,
                "with-header": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.showDrawer = $event
                }
              }
            },
            [
              _c("div", { staticClass: "drawer_box" }, [
                _c(
                  "div",
                  { staticClass: "drawer_main_content" },
                  [
                    _vm.showCate
                      ? _c("div", { staticClass: "header" }, [
                          _c("p", { staticClass: "head_title" }, [
                            _vm._v("Category")
                          ])
                        ])
                      : _c("div", { staticClass: "header" }, [
                          _c("p", { staticClass: "head_title" }, [
                            _vm._v("Filter")
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "head_clear",
                              on: {
                                click: function($event) {
                                  return _vm.clearAllHandel()
                                }
                              }
                            },
                            [_vm._v("Clear all")]
                          )
                        ]),
                    _vm._v(" "),
                    _vm.showCate
                      ? [
                          _c(
                            "div",
                            {
                              staticClass: "all-product",
                              on: { click: _vm.clearBrandHandel }
                            },
                            [_vm._v("All Products")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-collapse",
                            {
                              staticClass: "cust-collapse",
                              attrs: { accordion: true },
                              on: { change: _vm.handleChange },
                              model: {
                                value: _vm.activeNames,
                                callback: function($$v) {
                                  _vm.activeNames = $$v
                                },
                                expression: "activeNames"
                              }
                            },
                            _vm._l(_vm.cateArr, function(itm, index) {
                              return _c(
                                "el-collapse-item",
                                {
                                  key: index,
                                  staticClass: "cust-collapse-itm",
                                  attrs: { name: itm.cateName },
                                  on: {
                                    click: function($event) {
                                      return _vm.queryDataByBrand(itm)
                                    }
                                  }
                                },
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(itm.cateName) +
                                        "\n                    "
                                    ),
                                    _c("i", {
                                      staticClass: "cust-lg-i",
                                      class: {
                                        "cust-lg-i-active":
                                          _vm.activeNames == itm.cateName
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(itm.childrenList, function(itm2, idx) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "brand-app-cate",
                                        class: {
                                          "brand-app-cate-active":
                                            _vm.tmpCategoryId == itm2.id
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.queryDataByBrand(itm2)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: "javascript:void(0)"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                        " +
                                                _vm._s(itm2.cateName) +
                                                "\n                      "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            }),
                            1
                          )
                        ]
                      : [
                          _c(
                            "el-collapse",
                            {
                              on: { change: _vm.handleChange },
                              model: {
                                value: _vm.activeNames,
                                callback: function($$v) {
                                  _vm.activeNames = $$v
                                },
                                expression: "activeNames"
                              }
                            },
                            [
                              _vm.type == "product"
                                ? _c(
                                    "el-collapse-item",
                                    { attrs: { title: "Brand", name: "1" } },
                                    [
                                      _c("div", { staticClass: "cate_list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "cate_list_radio" },
                                          _vm._l(_vm.brandOption, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "el-radio-group",
                                              {
                                                key: index,
                                                on: {
                                                  change: function($event) {
                                                    return _vm.getList(false)
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.selectData
                                                      .collectionBrandId,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.selectData,
                                                      "collectionBrandId",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "selectData.collectionBrandId"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-radio",
                                                  {
                                                    attrs: {
                                                      label:
                                                        item.collectionBrandId
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.collectionBrandName
                                                      )
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-collapse-item",
                                {
                                  attrs: { title: "Wholesale Price", name: "2" }
                                },
                                [
                                  _c("div", { staticClass: "cate_list" }, [
                                    _c(
                                      "p",
                                      { staticClass: "price_cahnge_info" },
                                      [_vm._v("Price Range")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "price_input" },
                                      [
                                        _c("el-input", {
                                          attrs: { placeholder: "$Min" },
                                          model: {
                                            value: _vm.selectData.minPrice,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectData,
                                                "minPrice",
                                                $$v
                                              )
                                            },
                                            expression: "selectData.minPrice"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("-")]),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          attrs: { placeholder: "$Max" },
                                          model: {
                                            value: _vm.selectData.maxPrice,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectData,
                                                "maxPrice",
                                                $$v
                                              )
                                            },
                                            expression: "selectData.maxPrice"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              (this.queryObject &&
                                _vm.hairOpionsCateId.includes(
                                  this.queryObject.categoryId
                                )) ||
                              (this.queryObject &&
                                _vm.hairOpionsCateId2.includes(
                                  this.queryObject.categoryId
                                ))
                                ? _c(
                                    "el-collapse-item",
                                    {
                                      attrs: {
                                        title: "Hair Material",
                                        name: "3"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "cate_list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "cate_list_radio" },
                                          _vm._l(
                                            _vm.hairMaterialOption,
                                            function(item, index) {
                                              return _c(
                                                "el-radio-group",
                                                {
                                                  key: index,
                                                  on: {
                                                    change: _vm.addSelectList
                                                  },
                                                  model: {
                                                    value: _vm.hairMaterialItem,
                                                    callback: function($$v) {
                                                      _vm.hairMaterialItem = $$v
                                                    },
                                                    expression:
                                                      "hairMaterialItem"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: item } },
                                                    [_vm._v(_vm._s(item))]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (this.queryObject &&
                                _vm.hairOpionsCateId.includes(
                                  this.queryObject.categoryId
                                )) ||
                              (this.queryObject &&
                                _vm.hairOpionsCateId2.includes(
                                  this.queryObject.categoryId
                                ))
                                ? _c(
                                    "el-collapse-item",
                                    {
                                      attrs: {
                                        title: "Hair Texture",
                                        name: "4"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "cate_list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "cate_list_radio" },
                                          _vm._l(
                                            _vm.hairTextureOption,
                                            function(item, index) {
                                              return _c(
                                                "el-radio-group",
                                                {
                                                  key: index,
                                                  on: {
                                                    change: _vm.addSelectList
                                                  },
                                                  model: {
                                                    value: _vm.hairTextureItem,
                                                    callback: function($$v) {
                                                      _vm.hairTextureItem = $$v
                                                    },
                                                    expression:
                                                      "hairTextureItem"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: item } },
                                                    [_vm._v(_vm._s(item))]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.queryObject &&
                              _vm.hairOpionsCateId.includes(
                                this.queryObject.categoryId
                              )
                                ? _c(
                                    "el-collapse-item",
                                    {
                                      attrs: {
                                        title: "Hair Lace Design",
                                        name: "5"
                                      }
                                    },
                                    [
                                      _c("div", { staticClass: "cate_list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "cate_list_radio" },
                                          _vm._l(
                                            _vm.hairLaceDesignOption,
                                            function(item, index) {
                                              return _c(
                                                "el-radio-group",
                                                {
                                                  key: index,
                                                  on: {
                                                    change: _vm.addSelectList
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.hairLaceDesignItem,
                                                    callback: function($$v) {
                                                      _vm.hairLaceDesignItem = $$v
                                                    },
                                                    expression:
                                                      "hairLaceDesignItem"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: item } },
                                                    [_vm._v(_vm._s(item))]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (this.queryObject &&
                                _vm.hairOpionsCateId.includes(
                                  this.queryObject.categoryId
                                )) ||
                              (this.queryObject &&
                                _vm.hairOpionsCateId2.includes(
                                  this.queryObject.categoryId
                                ))
                                ? _c(
                                    "el-collapse-item",
                                    {
                                      attrs: { title: "Hair Type", name: "6" }
                                    },
                                    [
                                      _c("div", { staticClass: "cate_list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "cate_list_radio" },
                                          _vm._l(_vm.hairTypeOption, function(
                                            item,
                                            index
                                          ) {
                                            return _c(
                                              "el-radio-group",
                                              {
                                                key: index,
                                                on: {
                                                  change: _vm.addSelectList
                                                },
                                                model: {
                                                  value: _vm.hairTypeItem,
                                                  callback: function($$v) {
                                                    _vm.hairTypeItem = $$v
                                                  },
                                                  expression: "hairTypeItem"
                                                }
                                              },
                                              [
                                                _c(
                                                  "el-radio",
                                                  { attrs: { label: item } },
                                                  [_vm._v(_vm._s(item))]
                                                )
                                              ],
                                              1
                                            )
                                          }),
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.queryObject &&
                              _vm.dressesOpionsCateId.includes(
                                this.queryObject.categoryId
                              )
                                ? _c(
                                    "el-collapse-item",
                                    { attrs: { title: "Style", name: "7" } },
                                    [
                                      _c("div", { staticClass: "cate_list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "cate_list_radio" },
                                          _vm._l(
                                            _vm.dressesStyleOption,
                                            function(item, index) {
                                              return _c(
                                                "el-radio-group",
                                                {
                                                  key: index,
                                                  on: {
                                                    change: _vm.addSelectList
                                                  },
                                                  model: {
                                                    value: _vm.dressesStyleItem,
                                                    callback: function($$v) {
                                                      _vm.dressesStyleItem = $$v
                                                    },
                                                    expression:
                                                      "dressesStyleItem"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: item } },
                                                    [_vm._v(_vm._s(item))]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.queryObject &&
                              _vm.dressesOpionsCateId.includes(
                                this.queryObject.categoryId
                              )
                                ? _c(
                                    "el-collapse-item",
                                    { attrs: { title: "Design", name: "8" } },
                                    [
                                      _c("div", { staticClass: "cate_list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "cate_list_radio" },
                                          _vm._l(
                                            _vm.dressesDesignOption,
                                            function(item, index) {
                                              return _c(
                                                "el-radio-group",
                                                {
                                                  key: index,
                                                  on: {
                                                    change: _vm.addSelectList
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dressesDesignItem,
                                                    callback: function($$v) {
                                                      _vm.dressesDesignItem = $$v
                                                    },
                                                    expression:
                                                      "dressesDesignItem"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: item } },
                                                    [_vm._v(_vm._s(item))]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.queryObject &&
                              _vm.dressesOpionsCateId.includes(
                                this.queryObject.categoryId
                              )
                                ? _c(
                                    "el-collapse-item",
                                    {
                                      attrs: { title: "Fabric Type", name: "9" }
                                    },
                                    [
                                      _c("div", { staticClass: "cate_list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "cate_list_radio" },
                                          _vm._l(
                                            _vm.dressesFabricTypeOption,
                                            function(item, index) {
                                              return _c(
                                                "el-radio-group",
                                                {
                                                  key: index,
                                                  on: {
                                                    change: _vm.addSelectList
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dressesFabricTypeItem,
                                                    callback: function($$v) {
                                                      _vm.dressesFabricTypeItem = $$v
                                                    },
                                                    expression:
                                                      "dressesFabricTypeItem"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: item } },
                                                    [_vm._v(_vm._s(item))]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              this.queryObject &&
                              _vm.dressesOpionsCateId.includes(
                                this.queryObject.categoryId
                              )
                                ? _c(
                                    "el-collapse-item",
                                    {
                                      attrs: { title: "Occasion", name: "10" }
                                    },
                                    [
                                      _c("div", { staticClass: "cate_list" }, [
                                        _c(
                                          "div",
                                          { staticClass: "cate_list_radio" },
                                          _vm._l(
                                            _vm.dressesOccasionOption,
                                            function(item, index) {
                                              return _c(
                                                "el-radio-group",
                                                {
                                                  key: index,
                                                  on: {
                                                    change: _vm.addSelectList
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.dressesOccasionItem,
                                                    callback: function($$v) {
                                                      _vm.dressesOccasionItem = $$v
                                                    },
                                                    expression:
                                                      "dressesOccasionItem"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "el-radio",
                                                    { attrs: { label: item } },
                                                    [_vm._v(_vm._s(item))]
                                                  )
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                  ],
                  2
                ),
                _vm._v(" "),
                !_vm.showCate
                  ? _c(
                      "div",
                      { staticClass: "drawer_footer" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "footer_button",
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.closeHandel()
                              }
                            }
                          },
                          [_vm._v("Apply")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "search-top",
              class:
                _vm.type == "product" || _vm.type == "brand"
                  ? "search-top-product"
                  : _vm.plusSearch
                  ? "plus-search-top"
                  : ""
            },
            [
              _c(
                "div",
                { staticClass: "content" },
                [
                  _vm.type != "product" && _vm.type != "brand"
                    ? _c(
                        "div",
                        { staticClass: "crumb" },
                        [
                          _c(
                            "el-breadcrumb",
                            { attrs: { separator: "/" } },
                            [
                              _c(
                                "el-breadcrumb-item",
                                { attrs: { to: { path: "/" } } },
                                [_vm._v("Home")]
                              ),
                              _vm._v(" "),
                              _c("el-breadcrumb-item", [
                                _vm._v(_vm._s(_vm.value))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type !== "product" && _vm.type != "brand"
                    ? _c("div", { staticClass: "result-title" }, [
                        _vm._v(
                          "\n          Search Results for " +
                            _vm._s(_vm.value) +
                            "\n        "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "product" &&
                  (_vm.value === "" ||
                    _vm.value === undefined ||
                    _vm.value === null)
                    ? _c("div", { staticClass: "result-title" }, [
                        _vm.isNewProduct
                          ? _c("span", [_vm._v("New Releases")])
                          : _c("span", [
                              _vm._v(_vm._s(_vm.showSearchForObject.menuName))
                            ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type === "product" ? _c("div") : _vm._e(),
                  _vm._v(" "),
                  _vm.type == "brand"
                    ? [
                        !_vm.showMenuApp
                          ? _c(
                              "div",
                              { staticClass: "brand-select" },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "cust-select",
                                    class: {
                                      "cust-select-click":
                                        _vm.selectData.sortValue
                                    },
                                    attrs: {
                                      placeholder: "Sort by",
                                      "popper-class": "cust-select-option"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.getList(false)
                                      }
                                    },
                                    model: {
                                      value: _vm.selectData.sortValue,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectData,
                                          "sortValue",
                                          $$v
                                        )
                                      },
                                      expression: "selectData.sortValue"
                                    }
                                  },
                                  _vm._l(_vm.sortOption, function(item, id) {
                                    return _c("el-option", {
                                      key: id,
                                      attrs: {
                                        label: item.lable,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-dropdown",
                                  {
                                    class: {
                                      "cust-select-click":
                                        _vm.selectData.minPrice ||
                                        _vm.selectData.maxPrice
                                    },
                                    staticStyle: { margin: "0 10px 15px 0" },
                                    attrs: {
                                      "hide-on-click": false,
                                      trigger: "click"
                                    },
                                    on: {
                                      "visible-change": function($event) {
                                        return _vm.dropdownHandel()
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "el-dropdown-link" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.PriceValue)
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-arrow-down el-icon--right"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-dropdown-menu",
                                      {
                                        class: _vm.dropdownEdit
                                          ? "hidden_dropdown"
                                          : "show_dropdown",
                                        staticStyle: {
                                          padding: "10px",
                                          width: "200px"
                                        },
                                        attrs: { slot: "dropdown" },
                                        slot: "dropdown"
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              margin: "0 0 10px 0",
                                              color: "#909399"
                                            }
                                          },
                                          [_vm._v("Price Range")]
                                        ),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticStyle: { margin: "0 0 10px 0" },
                                          attrs: { placeholder: "$Min" },
                                          on: { input: _vm.changePriceMin },
                                          model: {
                                            value: _vm.selectData.minPrice,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectData,
                                                "minPrice",
                                                $$v
                                              )
                                            },
                                            expression: "selectData.minPrice"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticStyle: { margin: "0 0 10px 0" },
                                          attrs: { placeholder: "$Max" },
                                          on: { input: _vm.changePriceMax },
                                          model: {
                                            value: _vm.selectData.maxPrice,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selectData,
                                                "maxPrice",
                                                $$v
                                              )
                                            },
                                            expression: "selectData.maxPrice"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              background: "#262B2F",
                                              color: "#fff"
                                            },
                                            attrs: { type: "primary" },
                                            on: {
                                              click: function($event) {
                                                return _vm.selectPriceHandel()
                                              }
                                            }
                                          },
                                          [_vm._v("Apply")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showMenuApp
                    ? [
                        _vm.type == "product"
                          ? _c(
                              "div",
                              { staticClass: "select-lists select-lists2" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter_type_button filter_type_button1"
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/img/1.3.7-1.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "el-popover",
                                      {
                                        attrs: {
                                          placement: "bottom",
                                          width: "245",
                                          trigger: "click"
                                        },
                                        model: {
                                          value: _vm.popoverVisible,
                                          callback: function($$v) {
                                            _vm.popoverVisible = $$v
                                          },
                                          expression: "popoverVisible"
                                        }
                                      },
                                      [
                                        _vm._l(_vm.sortOption, function(
                                          item,
                                          id
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: id,
                                              staticClass: "story_box"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  class:
                                                    _vm.selectData.sortValue ==
                                                    item.value
                                                      ? "story_box_li li_color"
                                                      : "story_box_li",
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.sortHandel(
                                                        item.value
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.lable))]
                                              )
                                            ]
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "el-button",
                                          {
                                            staticStyle: { color: "#5d5d5d" },
                                            attrs: { slot: "reference" },
                                            slot: "reference"
                                          },
                                          [_vm._v("Sort by")]
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("el-divider", {
                                  attrs: { direction: "vertical" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter_type_button filter_type_button2",
                                    on: {
                                      click: function($event) {
                                        return _vm.phoneFilterHandel()
                                      }
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/img/1.3.7-0.png",
                                        alt: ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("p", [_vm._v("Filter")])
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm.type == "brand"
                          ? _c("div", { staticClass: "brand-app-search" }, [
                              _c(
                                "div",
                                { staticClass: "con-select" },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        width: "245",
                                        trigger: "click"
                                      },
                                      model: {
                                        value: _vm.popoverVisible,
                                        callback: function($$v) {
                                          _vm.popoverVisible = $$v
                                        },
                                        expression: "popoverVisible"
                                      }
                                    },
                                    [
                                      _vm._l(_vm.sortOption, function(
                                        item,
                                        id
                                      ) {
                                        return _c(
                                          "div",
                                          { key: id, staticClass: "story_box" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class:
                                                  _vm.selectData.sortValue ==
                                                  item.value
                                                    ? "story_box_li li_color"
                                                    : "story_box_li",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.sortHandel(
                                                      item.value
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(item.lable))]
                                            )
                                          ]
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("img", {
                                        attrs: {
                                          slot: "reference",
                                          src:
                                            "https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/img/1.3.7-1.png",
                                          alt: ""
                                        },
                                        slot: "reference"
                                      })
                                    ],
                                    2
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "con-select",
                                  on: {
                                    click: function($event) {
                                      return _vm.phoneFilterHandel()
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src:
                                        "https://shopvidi.oss-cn-beijing.aliyuncs.com/homepage-img/img/1.3.7-0.png",
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "con-select2",
                                  class: {
                                    "con-select2-active": _vm.tmpSelCategoryName
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickCate()
                                    }
                                  }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.tmpSelCategoryName
                                          ? _vm.tmpSelCategoryName
                                          : "Category"
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "down" })
                                ]
                              )
                            ])
                          : _vm._e()
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.type == "product" && !_vm.showMenuApp
                    ? _c(
                        "div",
                        { staticClass: "select-lists" },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "cust-select",
                              class: {
                                "cust-select-click": _vm.selectData.sortValue
                              },
                              attrs: {
                                placeholder: "Sort by",
                                "popper-class": "cust-select-option"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.getList(false)
                                }
                              },
                              model: {
                                value: _vm.selectData.sortValue,
                                callback: function($$v) {
                                  _vm.$set(_vm.selectData, "sortValue", $$v)
                                },
                                expression: "selectData.sortValue"
                              }
                            },
                            _vm._l(_vm.sortOption, function(item, id) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.lable, value: item.value }
                              })
                            }),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "cust-select",
                              class: {
                                "cust-select-click":
                                  _vm.selectData.collectionBrandId
                              },
                              attrs: {
                                placeholder: "Brand",
                                "popper-class": "cust-select-option"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.getList(false)
                                }
                              },
                              model: {
                                value: _vm.selectData.collectionBrandId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.selectData,
                                    "collectionBrandId",
                                    $$v
                                  )
                                },
                                expression: "selectData.collectionBrandId"
                              }
                            },
                            [
                              _vm._l(_vm.brandOption, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.collectionBrandName,
                                    value: item.collectionBrandId
                                  }
                                })
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                key: "clear",
                                staticClass: "select-clear",
                                attrs: { label: "Clear", value: "-1" }
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "el-dropdown",
                            {
                              staticClass: "cust-select",
                              class: {
                                "cust-select-click":
                                  _vm.selectData.minPrice ||
                                  _vm.selectData.maxPrice
                              },
                              staticStyle: { margin: "0 10px 15px 0" },
                              attrs: {
                                "hide-on-click": false,
                                trigger: "click"
                              },
                              on: {
                                "visible-change": function($event) {
                                  return _vm.dropdownHandel()
                                }
                              }
                            },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _vm._v(
                                  "\n                " + _vm._s(_vm.PriceValue)
                                ),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right"
                                })
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-dropdown-menu",
                                {
                                  class: _vm.dropdownEdit
                                    ? "hidden_dropdown"
                                    : "show_dropdown",
                                  staticStyle: {
                                    padding: "10px",
                                    width: "200px"
                                  },
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown"
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        margin: "0 0 10px 0",
                                        color: "#909399"
                                      }
                                    },
                                    [_vm._v("Price Range")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticStyle: { margin: "0 0 10px 0" },
                                    attrs: { placeholder: "$Min" },
                                    on: { input: _vm.changePriceMin },
                                    model: {
                                      value: _vm.selectData.minPrice,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectData,
                                          "minPrice",
                                          $$v
                                        )
                                      },
                                      expression: "selectData.minPrice"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("el-input", {
                                    staticStyle: { margin: "0 0 10px 0" },
                                    attrs: { placeholder: "$Max" },
                                    on: { input: _vm.changePriceMax },
                                    model: {
                                      value: _vm.selectData.maxPrice,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.selectData,
                                          "maxPrice",
                                          $$v
                                        )
                                      },
                                      expression: "selectData.maxPrice"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        background: "#262B2F",
                                        color: "#fff"
                                      },
                                      attrs: { type: "primary" },
                                      on: {
                                        click: function($event) {
                                          return _vm.selectPriceHandel()
                                        }
                                      }
                                    },
                                    [_vm._v("Apply")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          (this.queryObject &&
                            _vm.hairOpionsCateId.includes(
                              this.queryObject.categoryId
                            )) ||
                          (this.queryObject &&
                            _vm.hairOpionsCateId2.includes(
                              this.queryObject.categoryId
                            ))
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "cust-select",
                                  class: {
                                    "cust-select-click": _vm.hairMaterialItem
                                  },
                                  attrs: {
                                    placeholder: "Hair Material",
                                    "popper-class": "cust-select-option"
                                  },
                                  on: { change: _vm.addSelectList },
                                  model: {
                                    value: _vm.hairMaterialItem,
                                    callback: function($$v) {
                                      _vm.hairMaterialItem = $$v
                                    },
                                    expression: "hairMaterialItem"
                                  }
                                },
                                [
                                  _vm._l(_vm.hairMaterialOption, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    key: "clear",
                                    staticClass: "select-clear",
                                    attrs: { label: "Clear", value: "-1" }
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (this.queryObject &&
                            _vm.hairOpionsCateId.includes(
                              this.queryObject.categoryId
                            )) ||
                          (this.queryObject &&
                            _vm.hairOpionsCateId2.includes(
                              this.queryObject.categoryId
                            ))
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "cust-select",
                                  class: {
                                    "cust-select-click": _vm.hairTextureItem
                                  },
                                  attrs: {
                                    "popper-class": "cust-select-option",
                                    placeholder: "Hair Texture"
                                  },
                                  on: { change: _vm.addSelectList },
                                  model: {
                                    value: _vm.hairTextureItem,
                                    callback: function($$v) {
                                      _vm.hairTextureItem = $$v
                                    },
                                    expression: "hairTextureItem"
                                  }
                                },
                                [
                                  _vm._l(_vm.hairTextureOption, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    key: "clear",
                                    staticClass: "select-clear",
                                    attrs: { label: "Clear", value: "-1" }
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          this.queryObject &&
                          _vm.hairOpionsCateId.includes(
                            this.queryObject.categoryId
                          )
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "cust-select",
                                  class: {
                                    "cust-select-click": _vm.hairLaceDesignItem
                                  },
                                  attrs: {
                                    placeholder: "Hair Lace Design",
                                    "popper-class": "cust-select-option"
                                  },
                                  on: { change: _vm.addSelectList },
                                  model: {
                                    value: _vm.hairLaceDesignItem,
                                    callback: function($$v) {
                                      _vm.hairLaceDesignItem = $$v
                                    },
                                    expression: "hairLaceDesignItem"
                                  }
                                },
                                [
                                  _vm._l(_vm.hairLaceDesignOption, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    key: "clear",
                                    staticClass: "select-clear",
                                    attrs: { label: "Clear", value: "-1" }
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          (this.queryObject &&
                            _vm.hairOpionsCateId.includes(
                              this.queryObject.categoryId
                            )) ||
                          (this.queryObject &&
                            _vm.hairOpionsCateId2.includes(
                              this.queryObject.categoryId
                            ))
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "cust-select",
                                  class: {
                                    "cust-select-click": _vm.hairTypeItem
                                  },
                                  attrs: {
                                    placeholder: "Hair Type",
                                    "popper-class": "cust-select-option"
                                  },
                                  on: { change: _vm.addSelectList },
                                  model: {
                                    value: _vm.hairTypeItem,
                                    callback: function($$v) {
                                      _vm.hairTypeItem = $$v
                                    },
                                    expression: "hairTypeItem"
                                  }
                                },
                                [
                                  _vm._l(_vm.hairTypeOption, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    key: "clear",
                                    staticClass: "select-clear",
                                    attrs: { label: "Clear", value: "-1" }
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          this.queryObject &&
                          _vm.dressesOpionsCateId.includes(
                            this.queryObject.categoryId
                          )
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "cust-select",
                                  class: {
                                    "cust-select-click": _vm.dressesStyleItem
                                  },
                                  attrs: {
                                    placeholder: "Style",
                                    "popper-class": "cust-select-option"
                                  },
                                  on: { change: _vm.addSelectList },
                                  model: {
                                    value: _vm.dressesStyleItem,
                                    callback: function($$v) {
                                      _vm.dressesStyleItem = $$v
                                    },
                                    expression: "dressesStyleItem"
                                  }
                                },
                                [
                                  _vm._l(_vm.dressesStyleOption, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    key: "clear",
                                    staticClass: "select-clear",
                                    attrs: { label: "Clear", value: "-1" }
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          this.queryObject &&
                          _vm.dressesOpionsCateId.includes(
                            this.queryObject.categoryId
                          )
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "cust-select",
                                  class: {
                                    "cust-select-click": _vm.dressesDesignItem
                                  },
                                  attrs: {
                                    placeholder: "Design",
                                    "popper-class": "cust-select-option"
                                  },
                                  on: { change: _vm.addSelectList },
                                  model: {
                                    value: _vm.dressesDesignItem,
                                    callback: function($$v) {
                                      _vm.dressesDesignItem = $$v
                                    },
                                    expression: "dressesDesignItem"
                                  }
                                },
                                [
                                  _vm._l(_vm.dressesDesignOption, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    key: "clear",
                                    staticClass: "select-clear",
                                    attrs: { label: "Clear", value: "-1" }
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          this.queryObject &&
                          _vm.dressesOpionsCateId.includes(
                            this.queryObject.categoryId
                          )
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "cust-select",
                                  class: {
                                    "cust-select-click":
                                      _vm.dressesFabricTypeItem
                                  },
                                  attrs: {
                                    placeholder: "Fabric Type",
                                    "popper-class": "cust-select-option"
                                  },
                                  on: { change: _vm.addSelectList },
                                  model: {
                                    value: _vm.dressesFabricTypeItem,
                                    callback: function($$v) {
                                      _vm.dressesFabricTypeItem = $$v
                                    },
                                    expression: "dressesFabricTypeItem"
                                  }
                                },
                                [
                                  _vm._l(_vm.dressesFabricTypeOption, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    key: "clear",
                                    staticClass: "select-clear",
                                    attrs: { label: "Clear", value: "-1" }
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          this.queryObject &&
                          _vm.dressesOpionsCateId.includes(
                            this.queryObject.categoryId
                          )
                            ? _c(
                                "el-select",
                                {
                                  staticClass: "cust-select",
                                  class: {
                                    "cust-select-click": _vm.dressesOccasionItem
                                  },
                                  attrs: {
                                    placeholder: "Occasion",
                                    "popper-class": "cust-select-option"
                                  },
                                  on: { change: _vm.addSelectList },
                                  model: {
                                    value: _vm.dressesOccasionItem,
                                    callback: function($$v) {
                                      _vm.dressesOccasionItem = $$v
                                    },
                                    expression: "dressesOccasionItem"
                                  }
                                },
                                [
                                  _vm._l(_vm.dressesOccasionOption, function(
                                    item,
                                    index
                                  ) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: { label: item, value: item }
                                    })
                                  }),
                                  _vm._v(" "),
                                  _c("el-option", {
                                    key: "clear",
                                    staticClass: "select-clear",
                                    attrs: { label: "Clear", value: "-1" }
                                  })
                                ],
                                2
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    class: _vm.showMenuApp ? "tags tags_margin" : "tags"
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticClass: "content"
            },
            [
              _c("CardCom", {
                attrs: {
                  data: _vm.list,
                  type: _vm.type == "product" || _vm.type == "brand" ? 4 : 5,
                  spu: _vm.spuItem,
                  isShowBrandTag: _vm.isShowBrandTag,
                  contentType: "shopping"
                },
                on: {
                  showLogin: _vm.showLoginHandle,
                  clickHandle: _vm.clickHandle,
                  setShowAn: _vm.setShowAn
                }
              }),
              _vm._v(" "),
              _c("PageCom", {
                attrs: { currentPage: _vm.currentPage, total: _vm.total },
                on: {
                  handleSizeChange: _vm.handleSizeChange,
                  handleCurrentChange: _vm.handleCurrentChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.type != "product" && _vm.type != "brand"
        ? _c("footer-com", { key: _vm.showan, attrs: { value: _vm.showan } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ce016af", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ce016af","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search/index.vue
// module id = null
// module chunks = 